


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Domain } from '@/interfaces/domain';


@Component({})
export default class FormBookDemo extends Vue {
  @Prop({ default: null }) title: string;
  @Prop({ default: '' }) text: string;
  @Prop({ default: '80vh' }) height: string;
  @Prop({ default: 'bookdemo' }) mode: 'bookdemo' | 'customer';

  get bookDemoUrl() {
    const domain: Domain = this.$vmx.domain.domain;
    const url = this.mode == 'bookdemo' ? domain.calendlyBookdemo : domain.calendlyCustomer;

    return url ? url
      + '?embed_domain=app.projektagenten'
      +'&embed_type=PopupText'
      +'&hide_event_type_details=1'
      +'&hide_gdpr_banner=0'
      +'&primary_color=007FAD'
      : null
  }
}
